import * as Redux from 'redux';

import { addressUtils } from '../../../utils';
import * as Api from '../../Api';
import axios from '../../services/apiServices/apiServices';
import { storage } from '../../services/storageServices';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import { LoadDeliveryOptions } from '../Actions';

// legacy - remove when Address Internationalisation is 100% released
const addAddressToDeliveryLocations = (
  data: any,
  addressLayout: Api.AddressLayoutType,
): Api.AddressLayoutType[] =>
  data?.map((deliveryLocation) => ({
    ...deliveryLocation,
    displayAddress: {
      oneLine: addressUtils.getOneLineDisplayAddress(
        deliveryLocation,
        addressLayout,
      ),
      twoLine: addressUtils.getTwoLineDisplayAddress(
        deliveryLocation,
        addressLayout,
      ),
    },
  }));

// legacy - remove when Address Internationalisation is 100% released
export const LoadDeliveryLocations =
  () =>
  async (
    dispatch: Redux.Dispatch<Redux.Action>,
    getState: () => Store.State,
  ) => {
    const { flipdish, deliveryOptions } = getState();

    const deviceId = flipdish.Config.DeviceId;

    let addressLayout: Api.AddressLayoutType;
    if (flipdish.AppConfig.status === 'success') {
      addressLayout = flipdish.AppConfig.data.DeliveryAddressLayout;
    }

    // Work with cached version
    const deliveryLocationsJson = storage.getItem<Api.DeliveryLocation[]>(
      'flipdish-delivery-locations',
    );

    const formattedDeliveryLocationsJson = addAddressToDeliveryLocations(
      deliveryLocationsJson,
      addressLayout,
    );

    if (deliveryLocationsJson) {
      dispatch({
        type: 'LOAD_DELIVERY_LOCATIONS',
        payload: formattedDeliveryLocationsJson,
      });

      // TODO - maybe use a queue for this?
      const thunkDispatch = dispatch as any;
      formattedDeliveryLocationsJson.forEach((dl: any) => {
        const existing = deliveryOptions[dl.DeliveryLocationId];
        if (!existing || existing.status !== 'success') {
          thunkDispatch(LoadDeliveryOptions(dl, true));
        }
      });
    }

    await axios
      .get('/Map/DeliveryLocations', {
        params: {
          deviceId,
        },
      })
      .then((response) => {
        const data = response.data.Data;

        const formattedDeliveryLocations = addAddressToDeliveryLocations(
          data.DeliveryLocations,
          addressLayout,
        );

        Utilities.setInLocalStorage(
          'flipdish-delivery-locations',
          formattedDeliveryLocations,
        );

        dispatch({
          type: 'LOAD_DELIVERY_LOCATIONS',
          payload: formattedDeliveryLocations,
        });

        const thunkDispatch = dispatch as any;
        data.DeliveryLocations.forEach((dl) => {
          const existing = deliveryOptions[dl.DeliveryLocationId];

          if (!existing || existing.status !== 'success') {
            thunkDispatch(LoadDeliveryOptions(dl, true));
          }
        });
      })
      .catch((_e) => {
        console.error('Unable to get DeliveryLocations');
      });
  };

export const loadDeliveryLocations =
  (deliveryLocations: Api.DeliveryLocation[]) =>
  (dispatch: Redux.Dispatch<Redux.Action>, getState: () => Store.State) => {
    const { deliveryOptions } = getState();
    const thunkDispatch = dispatch as any;

    const deliveryLocationsJson = storage.getItem<Api.DeliveryLocation[]>(
      'flipdish-delivery-locations',
    );

    if (deliveryLocationsJson) {
      dispatch({
        type: 'LOAD_DELIVERY_LOCATIONS',
        payload: deliveryLocationsJson,
      });

      deliveryLocationsJson.forEach((dl: any) => {
        const existing = deliveryOptions[dl.DeliveryLocationId];

        if (!existing || existing.status !== 'success') {
          thunkDispatch(LoadDeliveryOptions(dl, true));
        }
      });
    }

    dispatch({
      type: 'LOAD_DELIVERY_LOCATIONS',
      payload: deliveryLocations,
    });

    deliveryLocations.forEach((dl) => {
      const existing = deliveryOptions[dl.DeliveryLocationId];

      if (!existing || existing.status !== 'success') {
        thunkDispatch(LoadDeliveryOptions(dl, true));
      }
    });
  };
